module.exports = __webpack_public_path__ + "static/og_image-826347f36f8d05db17f181fe957fc2ea.png";